import type {
    PayableServiceActivity,
    PayableServiceActivityValidatedAddEdit,
} from '@common/validation/payableServiceActivity';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/finance/payableServiceActivities';

export async function getAllPayableActivities(
    params: {
        isActive?: boolean;
        serviceId?: string;
    },
    signal: AbortSignal
): Promise<PayableServiceActivity[]> {
    const queryParams = new URLSearchParams({
        ...params,
        isActive: (!!params.isActive).toString(),
    });
    const url = `${baseUrl}?${queryParams.toString()}`;
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json.items ?? [];
}

export async function getOnePayableActivity(id: string, signal: AbortSignal): Promise<PayableServiceActivity> {
    const url = `${baseUrl}/${id}`;
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}

export async function updatePayableServiceActivity(
    id: string,
    payableServiceActivity: PayableServiceActivityValidatedAddEdit,
    signal: AbortSignal
): Promise<PayableServiceActivity> {
    const url = `${baseUrl}/${id}`;
    const result = await fetchJson({ body: payableServiceActivity, method: 'POST', signal, url });

    return result.json;
}

export async function createPayableServiceActivity(
    payableServiceActivity: PayableServiceActivityValidatedAddEdit,
    signal: AbortSignal
): Promise<PayableServiceActivity> {
    const url = `${baseUrl}`;
    const result = await fetchJson({ body: payableServiceActivity, method: 'POST', signal, url });

    return result.json;
}
